import React, { useContext } from 'react';
import PropType from 'prop-types';

import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import clsx from 'clsx';
import { NavLink, useNavigate } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import useAuthAPI from '../../hooks/network/useAuthAPI';
import NiceMobile from '../../assets/svg/NiceMobile';
import NatsteelMobile from '../../assets/svg/NatsteelMobile';
import NatSteelHeaderLogo from '../../assets/logos/NatSteelHeaderLogo.png';
import NICEHeaderLogo from '../../assets/logos/NICEHeaderLogo.png';
import Notification2 from './Notification2';
import useAuthHook from '../../hooks/custom-hooks/useAuthHook';
import { AppContext } from '../../context/AppContext';
import Cookies from 'js-cookie';

function Header2(props) {
  const { setOpenSidebar, isSidebarOpen } = props;
  const { logout } = useAuthAPI();
  const navigate = useNavigate();
  const { isAdUser } = useAuthHook();
  const { userProfile } = useContext(AppContext);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className='sticky top-0 z-[9] bg-nblue'>
      <div
        className={clsx(
          'relative my-0 mx-auto h-full max-w-screen-cwidth font-sans',
          'px-4 breakMax:py-1',
          'break:pr-11 break:pl-4',
        )}
      >
        <div className='flex items-center justify-between py-1.5 text-white break:py-3 maclg:py-4'>
          <div className='flex items-center'>
            {isSidebarOpen !== undefined && (
              <div className='mr-5'>
                <MenuIcon
                  className='cursor-pointer text-3xl text-white'
                  onClick={() => setOpenSidebar?.(!isSidebarOpen)}
                />
              </div>
            )}
            <div onClick={() => navigate('/')}>
              {/* Mobile Logo */}
              <div className={clsx('break:hidden', 'flex items-center justify-center')}>
                <div className='border-r-2 border-solid pr-2'>
                  <NiceMobile />
                </div>
                <div className='pl-2'>
                  <NatsteelMobile />
                </div>
              </div>
              {/* Desktop Logo */}
              <div
                className={clsx('hidden cursor-pointer break:flex', 'items-center justify-center')}
              >
                <div className='border-r-4 border-solid pr-4'>
                  <img className='h-[24px] w-full' src={NICEHeaderLogo} alt='NICEHeaderLogo' />
                </div>
                <div className='pl-4'>
                  <img
                    className='h-[24px] w-full'
                    src={NatSteelHeaderLogo}
                    alt='NatSteelHeaderLogo'
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='flex items-center'>
            <div className={clsx('mr-4 cursor-pointer break:mr-11 break:block')}>
              <NavLink to='widget-setting' key='profile' className='cursor-pointer hover:underline'>
                <SettingsIcon />
              </NavLink>
            </div>

            {window.location.pathname === '/' && (
              <div className={clsx('mr-4 cursor-pointer break:mr-11 break:block')}>
                <Notification2 />
              </div>
            )}
            <div className='flex items-center justify-center'>
              <p
                className={clsx(
                  'flex h-10 w-10 items-center justify-center rounded-full border-[3px] border-solid border-white',
                  'break:mr-4',
                )}
              >
                {isAdUser
                  ? Cookies?.get('user')?.split(' ')?.at(0)?.charAt(0)
                  : userProfile?.firstName?.split(' ')?.at(0)?.charAt(0)}
              </p>
              <div
                className={clsx('group break:relative break:block break:cursor-pointer', 'hidden')}
              >
                Hi{' '}
                {isAdUser
                  ? Cookies?.get('user')
                  : `${userProfile?.firstName || ''} ${userProfile?.lastName || ''}`}
                !
                <span className=''>
                  <ArrowDropDownIcon className='text-white' />
                </span>
                <div
                  className={clsx(
                    'pointer-events-none  invisible rounded-md bg-white px-5 py-5 text-nblue duration-200',
                    'absolute right-0 px-12 duration-200',
                    'group-hover:pointer-events-auto group-hover:visible',
                  )}
                  style={{
                    zIndex: 9999,
                    borderBottom: '1px solid #e5e5e5',
                    borderRight: '1px solid #e5e5e5',
                  }}
                >
                  <ul className=''>
                    {!isAdUser && (
                      <NavLink
                        to='user-profile'
                        key='profile'
                        className='cursor-pointer hover:underline'
                      >
                        Profile
                      </NavLink>
                    )}
                    <li
                      key='logout'
                      onClick={handleLogout}
                      className='cursor-pointer hover:underline'
                    >
                      Logout
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Header2.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  setOpenSidebar: PropType.any,
  isSidebarOpen: PropType.bool,
};

Header2.defaultProps = {
  setOpenSidebar: undefined,
  isSidebarOpen: undefined,
};

export default React.memo(Header2);
